import { render, staticRenderFns } from "./ProfileSubMenu.vue?vue&type=template&id=b30d1716&scoped=true&"
import script from "./ProfileSubMenu.vue?vue&type=script&lang=ts&"
export * from "./ProfileSubMenu.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileSubMenu.vue?vue&type=style&index=0&id=b30d1716&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30d1716",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VList,VListItem,VMenu,VRow,VSpacer})
